export default __webpack_public_path__ + "static/main-screenshots-generator-9e730676ffa3711e059be5a945e9117b.png";